import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {LayoutFullBleed} from "../../../../Components/Layout";
import {locations} from "../../../../Utilities/Location";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {loanLibraryCatalogApi} from "./loanLibraryCatalogApi";
import {LoanLibraryCatalogItem} from "./LoanLibraryCatalogItem";
import {SYSTEM_TYPES} from "../../libraryConstants";

export const LoanLibraryCatalogWhatsNewContainer = ({
                                                        handleApiCall,
                                                        redirect,
                                                    }: ContextProps) => {
    const [resources, setResources] = useState<Record<string, any>[]>([]);

    const handleEdit = (id: string) => {
        const path = locations.LOAN_LIBRARY_CATALOG_ITEM.getLink([id, SYSTEM_TYPES.LoanLibrary]).to;
        redirect(path);
    }

    useEffect(() => {
        const getResources = () => {
            handleApiCall(() => loanLibraryCatalogApi.getWhatsNew(), (results: Record<string, any>[]) => setResources(results));
        }

        getResources();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        <PageTitle h1="Loan Library"/>

        <LayoutFullBleed className={`catalog`}>
            <header>
                <h2>What&apos;s New</h2>
            </header>

            {
                resources.map((resource: Record<string, any>) => {
                    const handleClickEdit = () => handleEdit(resource.loanLibraryCatalogId);
                    return <LoanLibraryCatalogItem
                        key={resource.loanLibraryCatalogId}
                        handleClickEdit={handleClickEdit}
                        {...resource}
                    />;
                })
            }
            {
                isArrayNullOrEmpty(resources) &&
                <p className={`text-center`}>No results.</p>
            }

        </LayoutFullBleed>
    </>;
};
